window.addEventListener('load', () => {
  document
    .querySelectorAll<HTMLVideoElement>('[data-lazy-video]')
    .forEach((video) => {
      if (window.innerWidth > 567) {
        video.addEventListener('loadeddata', () => {
          video.classList.remove('hidden')
          video?.parentElement?.querySelector('img')?.classList.add('hidden')
        })

        const videoSrc = video.getAttribute('data-src')

        if (videoSrc !== null) {
          video.src = videoSrc
        }
      }
    })
})
